import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Readmore extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Readmore',
    refs: ['btn', 'content'],
    options: {
      labelClose: {
        type: String,
        default: 'Voir moins',
      },
      labelOpen: {
        type: String,
        default: 'Voir plus',
      },
    },
  };

  /**
   * On btn click
   * @returns {void}
   */
  onBtnClick() {
    ['opacity-0', 'fixed', 'pointer-events-none'].map((v) =>
      this.$refs.content.classList.toggle(v),
    );
    this.open = !this.open;

    if (this.open) {
      this.$refs.btn.innerHTML = this.$options.labelClose;
    } else {
      this.$refs.btn.innerHTML = this.$options.labelOpen;
    }
  }
}
